import ClientError from '../client-error';
import errors from 'src/static/errors.json';

export default class NotFoundError extends ClientError {
  public static status = 404;
  public name = 'NotFoundError';
  constructor(message: string = errors.genericError) {
    super(message);
  }
}
